import util from '@bmp-vue/core/api/util'
const controller = 'VeiculosFornecedor'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  GetItem (th, parcela, anoVeiculo) {
    const item = th.$param.TabelaTaxas.find(t =>
      t.prazo === parcela &&
      anoVeiculo >= t.anoInicio &&
      anoVeiculo <= t.anoFim
    )

    return item?.taxas ?? null
  },
  GetInfo (th, anoVeiculo, prazo) {
    const tabela = th.$param.TabelaTaxas.find(item => {
      return anoVeiculo >= item.anoInicio && anoVeiculo <= item.anoFim && prazo === item.prazo;
    });

    if (!tabela) return null;

    return {
      entrada: tabela.entrada,
      valorMax: tabela.valorMax
    };
  },
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.PropostaDadosVeiculo.ZeroKM) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTAVEICULO_ZEROKM', ValorCampo: th.model.PropostaDadosVeiculo.ZeroKM }) }
    if ([null, undefined].indexOf(th.model.ModeloComissao) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_MODELOCOMISSAO', ValorCampo: th.model.ModeloComissao }) }
    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR', ValorCampo: th.model.ObservacaoVendedor }) }
    if ([null, undefined].indexOf(th.model.PropostaDadosVeiculo.Cilindradas) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTAVEICULO_CILINDRADAS', ValorCampo: th.model.PropostaDadosVeiculo.Cilindradas }) }

    if (campos.length > 0) { th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos }) }
  },
  CadastraAssinantes (th, documentoEmitente, callback) {
    const assinantes = [];
    const parameters = [{ name: 'CodigoProposta', value: th.model.Codigo }]
    th.$api.Multiplo.Post('CarregarPropostaParticipantes', { parameters }).then(res => {
      th.$api.Multiplo.Post('FindRecordProdutoRede').then(function (resProdutoRede) {
        res.forEach(assinante => {
          const addAssinante = {
            Nome: assinante.Nome,
            Documento: assinante.Documento,
            NotificarPorEmail: th.$aux.NotificaPorEmail.includes(resProdutoRede.ModeloNotificacaoAssinatura),
            NotificarPorWhatsApp: th.$aux.NotificaPorWhatsApp.includes(resProdutoRede.ModeloNotificacaoAssinatura),
            Descricao: assinante.Documento === th.$api.UI.Format.SomenteAlfanumerico(documentoEmitente) ? 'EMITENTE' : 'AVALISTA',
            TelefoneCelular: assinante.TelefoneCelular,
            Email: assinante.Email
          }

          assinantes.push(addAssinante);
        })

        if (assinantes.length > 0) {
          const dto = {
            CodigoProposta: th.model.Codigo,
            CodigoOperacao: th.model.CodigoOperacao
          }

          th.$api.Multiplo.Post('PropostaAssinaturaCCB', { dto, assinantes }).then(response => {
            if (th.$api.UI.PostAction(response)) {
              if (callback && typeof callback === 'function') callback();
            }
          })
        }
      })
    })
  },
  AllowedDates (th, value) {
    return ![0, 6].includes(th.$api.UI.Parse.Date(value).getDay())
  },
  TipoErroGravameEnum: {
    Externo: 1,
    Interno: 2
  },
})

export default ctrl
